var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{attrs:{"title":"Indicatori"}},[_c('b-row',[_c('b-col',[_c('IPGBar',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBar),expression:"showBar"}],attrs:{"refreshCallback":_vm.updateParamsAndRefresh,"sites":_vm.sites}})],1)],1),_vm._v(" "),_c('div',{ref:"container"})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f7bb4702","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard/IPG/IPG.vue
// module id = null
// module chunks = 